import _get from 'lodash/get';
import _flattenDeep from 'lodash/flattenDeep';
import FilterSelection from '../models/FilterSelection';
import { FILTER_TYPE } from './constants';

const parseListNode = (node) => {

    if (!node || !node.children || node.children.length < 1) return null;

    const first = new FilterSelection(node.children[0]);
    const rest = node.children.slice(1);

    const clause = rest.reduce((acc, node) => {

        acc.addSelectedValue(node);

        return acc;

    }, first);

    return clause;

};

const parseRangeNode = (node) => {

    if (
        !node
        || !node.children
        || node.children.length < 2
    ) return null;

    let minVal = node.children[0].value;
    let maxVal = node.children[1].value;

    if (typeof minVal === 'string') {

        minVal = JSON.stringify(minVal);

    }

    if (typeof maxVal === 'string') {

        maxVal = JSON.stringify(maxVal);

    }

    const range = {
        ...node.children[0],
        type: FILTER_TYPE.range,
        operator: '=',
        value: `{{ ${minVal}, ${maxVal} }}`,
        displayValue: `${node.children[0].displayValue} - ${node.children[1].displayValue}`,
    };

    return new FilterSelection(range);

};

const parseLogicalOperatorNode = (node) => {

    const clauses = node.children.map(n => parseNode(n)).filter(n => n !== null);

    const [first] = clauses;

    if (Array.isArray(first)) {

        first[first.length - 1].logicalConjunctionOperator = node.name;

    } else {

        first.logicalConjunctionOperator = node.name;

    }

    return clauses;

};

const parseQueryNode = (node) => {

    return new FilterSelection(node);

};

const parseOptionNode = (node) => {

    const [primary] = node.identifiers;
    const secondary = node.name.split(' ')[3];

    return {
        type: 'SORT',
        value: `${primary} ${secondary}`,
    };

};

const parseNode = (node) => {

    switch (node.nodeType) {

        case 'LIST':
            return parseListNode(node);
        case 'LOGICAL_OPERATOR':
            return parseLogicalOperatorNode(node);
        case 'QUERY':
            return parseQueryNode(node);
        case 'OPTION':
            return parseOptionNode(node);
        case 'RANGE':
            return parseRangeNode(node);
        default:
            return [];

    }

};

const parseQueryInfo = (queryInfoData) => {

    const queryChildren = _get(queryInfoData, 'queryInfo[0].graph.children', []);
    const clauses = queryChildren.map(n => parseNode(n));
    const { filters, sort } = _flattenDeep(clauses).reduce((result, element) => {

        if (element.type === 'SORT') {

            result.sort = element.value;

        } else {

            result.filters.push(element);

        }

        return result;

    }, {
        filters: [],
        sort,
    });

    return {
        filters,
        sort,
    };

};

export default parseQueryInfo;
